import React from 'react';
import { Field } from 'redux-form';
import { Accordion, Grid, Button, Form, Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import {
  SelectField,
  CheckboxField,
  DatePickerField,
} from 'Common/SemanticWrapper';
import { WarehouseReportEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { DatePickerCustomButton } from 'Components';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { WAREHOUSE_KITCHEN_LOAD_FORM_NAME } from 'Common/FormEnum';
import { SiteComponent } from 'Common/SiteComponent';
import { SiteTypeEnum } from 'Common/Constants/Enumeration/SiteTypeEnum';

import { sortByOptions, groupByOptions } from '../helper';

const WarehouseLoadComponent = props => {
  const {
    clearFilter,
    onChangeOfFromDT,
    onChangeOfToDT,
    activeIndexes,
    handleCollapsePanelClick,
    storageLocationOptions,
    truckRouteOptions,
    fromDateMax,
    toDateMin,
    data,
    fetchWHKITListLoading,
    fetchTruckRouteListLoading,
    storageLocationDataLoading,
  } = props;
  return (
    <Form>
      <Grid>
        <Grid.Row columns={3}>
          <Grid.Column className={'pl-0'}>
            <SiteComponent
              label={'Warehouse/Kitchen'}
              name={WarehouseReportEnum.WarehouseKitchen}
              onChange={this.dropDownChange}
              isForm={true}
              siteMasterTypeIds={[SiteTypeEnum.Warehouse, SiteTypeEnum.Kitchen]}
              style={{ marginBottom: 10 }}
              isAllRequired={false}
              checkIsLicensed={false}
              isAllValueZero={true}
              siteOptions={data}
              loading={fetchWHKITListLoading}
            />
          </Grid.Column>
          <Grid.Column verticalAlign={'bottom'} style={{ marginBottom: 10 }}>
            <Field
              name={WarehouseReportEnum.IncludeItemsForOpenOrder}
              component={CheckboxField}
              toggle
              label={'Include items from open orders'}
            />
          </Grid.Column>
          <Grid.Column verticalAlign={'bottom'} textAlign={'right'}>
            <Button
              type="button"
              content="Clear Filters"
              className="clear-filter"
              onClick={clearFilter}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={3}>
          <Grid.Column className={'pl-0'}>
            <Field
              component={DatePickerField}
              label={'Delivery Date Begin'}
              dateFormat={DATE_FORMAT_FOR_UI}
              name={WarehouseReportEnum.DateFrom}
              onChange={onChangeOfFromDT}
              maxDate={fromDateMax}
              dropdownMode="select"
              customInput={<DatePickerCustomButton />}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              component={DatePickerField}
              label={'Delivery Date End'}
              dateFormat={DATE_FORMAT_FOR_UI}
              name={WarehouseReportEnum.DateTo}
              onChange={onChangeOfToDT}
              type={'text'}
              minDate={toDateMin}
              customInput={<DatePickerCustomButton />}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Accordion fluid styled>
            <Accordion.Title
              active={activeIndexes.indexOf(0) !== -1}
              index={0}
              onClick={handleCollapsePanelClick}
            >
              <Icon name="dropdown" />
              <span className="text-orange">Filter By</span>
            </Accordion.Title>
            <Accordion.Content active={activeIndexes.indexOf(0) !== -1}>
              <Grid>
                <Grid.Row columns={3}>
                  <Grid.Column>
                    <Field
                      component={SelectField}
                      label={'Storage Location'}
                      name={WarehouseReportEnum.StorageLocation}
                      options={storageLocationOptions}
                      loading={storageLocationDataLoading}
                      upward
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Field
                      component={SelectField}
                      label={'Truck Route'}
                      name={WarehouseReportEnum.TruckRoute}
                      options={truckRouteOptions}
                      loading={fetchTruckRouteListLoading}
                      upward
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <SiteComponent
                      label={'Ordering Site'}
                      name={WarehouseReportEnum.OrderingSite}
                      isForm={true}
                      siteMasterTypeIds={[SiteTypeEnum.School, SiteTypeEnum.Kitchen]}
                      style={{ marginBottom: 10 }}
                      isActive={true}
                      isAllRequired={true}
                      isAllValueZero={true}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndexes.indexOf(1) !== -1}
              index={1}
              onClick={handleCollapsePanelClick}
            >
              <Icon name="dropdown" />
              <span className="text-orange">Sort By</span>
            </Accordion.Title>
            <Accordion.Content active={activeIndexes.indexOf(1) !== -1}>
              <Grid>
                <Grid.Row columns={3} className={'pt10'}>
                  <Grid.Column width={13} verticalAlign={'bottom'}>
                    <ReduxFormButtonGroup
                      options={sortByOptions}
                      formName={WAREHOUSE_KITCHEN_LOAD_FORM_NAME}
                      fieldName={WarehouseReportEnum.SortBy}
                      type={'button'}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndexes.indexOf(2) !== -1}
              index={2}
              onClick={handleCollapsePanelClick}
            >
              <Icon name="dropdown" />
              <span className="text-orange">Group By</span>
            </Accordion.Title>
            <Accordion.Content active={activeIndexes.indexOf(2) !== -1}>
              <Grid>
                <Grid.Row columns={3} className={'pt10'}>
                  <Grid.Column width={13} verticalAlign={'bottom'}>
                    <ReduxFormButtonGroup
                      options={groupByOptions}
                      formName={WAREHOUSE_KITCHEN_LOAD_FORM_NAME}
                      fieldName={WarehouseReportEnum.GroupBy}
                      type={'button'}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Accordion.Content>
          </Accordion>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

WarehouseLoadComponent.propTypes = {
  activeIndexes: PropTypes.array,
  clearFilter: PropTypes.func,
  fromDateMax: PropTypes.object,
  handleCollapsePanelClick: PropTypes.func,
  onChangeOfFromDT: PropTypes.func,
  onChangeOfToDT: PropTypes.func,
  storageLocationOptions: PropTypes.array,
  toDateMin: PropTypes.object,
  truckRouteOptions: PropTypes.array,
  data: PropTypes.array,
  fetchWHKITListLoading: PropTypes.bool,
  fetchTruckRouteListLoading: PropTypes.bool,
  storageLocationDataLoading: PropTypes.bool,
};

WarehouseLoadComponent.defaultProps = {
  activeIndexes: [],
  clearFilter: () => {},
  handleCollapsePanelClick: () => {},
  onChangeOfFromDT: () => {},
  onChangeOfToDT: () => {},
  fetchWHKITListLoading: false,
  fetchTruckRouteListLoading: false,
  storageLocationDataLoading: false,
  fromDateMax: null,
  toDateMin: null,
  data: [],
  storageLocationOptions: [],
  truckRouteOptions: [],
};

export default WarehouseLoadComponent;



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/warehousepicklist/components/WarehouseLoad.js